import _BackTop from './Backtop';

import './style';

export * from './type';

export const BackTop = _BackTop;

export default { BackTop };
